<template>
  <div>
    <v-layout row wrap class="mt-2">
      <v-flex lg6 xs12>
        <h3 class="mt-1">Le locataire</h3>
        <v-list v-if="project">
          <div style="padding: 0 10px">
            <v-switch
              v-model="project.coEnabled"
              :label="`Co-demandeur`"
              :readonly="!editMode"
              :disabled="!editMode"
            />
            <v-divider />
          </div>
          <template v-for="item in leclient">
            <FormLine
              :item="item"
              v-model="project"
              :key="item.name"
              :edit-mode="editMode"
            ></FormLine>
            <v-divider :key="`${item.name}-divider`" />
          </template>
        </v-list>
        <h3 class="mt-4">Son entreprise</h3>
        <v-list v-if="project">
          <template v-for="item in origin">
            <FormLine
              :item="item"
              :key="item.name"
              v-model="project"
              :edit-mode="editMode"
            ></FormLine>
            <v-divider :key="`${item.name}-divider`" />
          </template>
        </v-list>
      </v-flex>
      <v-flex xs12 lg6>
        <h3
          class="ml-3 mt-1"
          :class="{ 'missing-section': !check('customerSituation') }"
        >
          Situation du client (privé)
        </h3>
        <v-list three-line v-if="project">
          <v-list-tile class="no-height">
            <v-list-tile-content class="no-height">
              <v-textarea
                v-model="project.customerSituation"
                style="width: 100%"
                :readonly="!editMode"
                :disabled="!editMode"
              />
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
        <div class="situation-client-hints general-hints">
          <h4>Fil conducteur</h4>
          <ul>
            <li>Nouveau salaire, Prime d'activités, APL</li>
            <li>Type de contrat</li>
            <li>Garants</li>
            <li>Besoin de garantie visale ?</li>
            <li>Frise de projet / Rétroplanning</li>
            <li>Indications particulières du client</li>
          </ul>
        </div>
        <h3
          class="ml-3"
          :class="{ 'missing-section': !check('aboutYouAdmin') }"
        >
          A propos du client
        </h3>
        <h4 class="ml-3 mt-2"></h4>
        <v-list three-line v-if="project">
          <v-list-tile class="no-height">
            <v-list-tile-content class="no-height">
              <v-list-tile-title>Il a écrit :</v-list-tile-title>
              <div class="no-clamp fsz">
                {{ project.aboutYou || "Non défini" }}
              </div>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile class="no-height">
            <v-list-tile-content class="no-height">
              <v-list-tile-title>HiL a écrit :</v-list-tile-title>
              <v-textarea
                v-model="project.aboutYouAdmin"
                style="width: 100%"
                :readonly="!editMode"
                :disabled="!editMode"
              ></v-textarea>
            </v-list-tile-content>
          </v-list-tile>
          <div class="general-hints">
            <h4>Fil conducteur</h4>
            <ul>
              <li>Pourquoi il déménage ?</li>
              <li>Situation personnelle et pro ?</li>
              <li>Constitution de la famille & Style de vie (hobbies...)</li>
              <li>
                Etat des recherches, a-t-il déjà été accompagné et quand ?
              </li>
              <li>Connaissance du mobilipass</li>
              <li>Une autre entreprise a-t-elle été mandatée ? (⚠ si oui)</li>
              <li>Planning des dispos pour les visites</li>
            </ul>
          </div>
        </v-list>
      </v-flex>
    </v-layout>
    <template v-if="project.coEnabled">
      <h2>Le co-locataire</h2>
      <v-layout row wrap class="mt-2">
        <v-flex lg6 xs12>
          <h3 class="mt-1">Infos</h3>
          <v-list v-if="project">
            <template v-for="item in coClient">
              <FormLine
                :item="item"
                v-model="project"
                :key="item.name"
                :edit-mode="editMode"
              ></FormLine>
              <v-divider :key="`${item.name}-divider`" />
            </template>
          </v-list>
        </v-flex>
        <v-flex lg6 xs12>
          <h3 class="mt-1">Son entreprise</h3>
          <v-list v-if="project">
            <template v-for="item in coOrigin">
              <FormLine
                :item="item"
                :key="item.name"
                v-model="project"
                :edit-mode="editMode"
              ></FormLine>
              <v-divider :key="`${item.name}-divider`" />
            </template>
          </v-list>
        </v-flex>
      </v-layout>
    </template>
    <h2>Le garant 1</h2>
    <v-layout row wrap class="mt-2">
      <v-flex lg6 xs12>
        <h3 class="mt-1">Infos</h3>
        <v-list v-if="project">
          <template v-for="item in g1Client">
            <FormLine
              :item="item"
              v-model="project"
              :key="item.name"
              :edit-mode="editMode"
            ></FormLine>
            <v-divider :key="`${item.name}-divider`" />
          </template>
        </v-list>
      </v-flex>
      <v-flex lg6 xs12>
        <h3 class="mt-1">Son entreprise</h3>
        <v-list v-if="project">
          <template v-for="item in g1Origin">
            <FormLine
              :item="item"
              :key="item.name"
              v-model="project"
              :edit-mode="editMode"
            ></FormLine>
            <v-divider :key="`${item.name}-divider`" />
          </template>
        </v-list>
      </v-flex>
    </v-layout>
    <h2>Le garant 2</h2>
    <v-layout row wrap class="mt-2">
      <v-flex lg6 xs12>
        <h3 class="mt-1">Infos</h3>
        <v-list v-if="project">
          <template v-for="item in g2Client">
            <FormLine
              :item="item"
              v-model="project"
              :key="item.name"
              :edit-mode="editMode"
            ></FormLine>
            <v-divider :key="`${item.name}-divider`" />
          </template>
        </v-list>
      </v-flex>
      <v-flex lg6 xs12>
        <h3 class="mt-1">Son entreprise</h3>
        <v-list v-if="project">
          <template v-for="item in g2Origin">
            <FormLine
              :item="item"
              :key="item.name"
              v-model="project"
              :edit-mode="editMode"
            ></FormLine>
            <v-divider :key="`${item.name}-divider`" />
          </template>
        </v-list>
      </v-flex>
    </v-layout>
    <v-flex xs12 class="d-flex d-flex-initial justify-end">
      <v-btn @click="downloadFiche">
        <v-icon class="mr-2">cloud_download</v-icon>
        Fiche de renseignement
      </v-btn>
    </v-flex>
  </div>
</template>

<script>
import { getTenantFields } from "@/data/leaseData";
import FormLine from "../commons/FormLine.vue";
import { checkFormLine, fetchHil } from "../../utils";
import { downloadFile } from "../../../../webapp-commons/functions";

export default {
  props: ["project", "editMode", "validators"],
  components: {
    FormLine
  },
  inject: ["$validator"],
  data() {
    return {
      tab: 0,
      ...getTenantFields.call(this, this.validators)
    };
  },
  methods: {
    async downloadFiche() {
      const data = await fetchHil(
        `/documents/for/${this.project._id}/document/templated/fiche_renseignement`
      );
      await downloadFile(data);
    },
    check(att) {
      return checkFormLine(
        this.validators[att],
        this.project[att],
        this.project
      );
    }
  },
  computed: {}
};
</script>

<style scoped>
.no-clamp {
  -webkit-line-clamp: 1000 !important;
}

.fsz {
  font-size: 12px !important;
}

.missing-section {
  background: darkorange;
}

.general-hints {
  color: #555;
  margin-left: 30px;
  margin-bottom: 24px;
}

h2 {
  background: grey;
  color: white;
  margin: 8px 8px 0 8px;
  padding-left: 8px;
}
</style>
